import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { themes } from "@/mocks/film";

export default function ThemesSection() {
  return (
    <section id="themes" className="scroll-mt-32 bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="06 / 主题解析"
            title="这部片真正在讨论什么"
            desc="抛开“伦理片”这个标签，影片其实在处理几个很具体的问题：亲情的边界、被看见的渴望、沉默的代价，以及克制的表达方式。"
            align="center"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {themes.map((theme, index) => (
            <Reveal key={theme.title} delay={(index % 2) * 80}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-7 flex gap-4 md:gap-5">
                <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center text-2xl md:text-[26px]">
                  <i className={theme.icon} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                    {theme.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{theme.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}